import { Popover, Transition } from "@headlessui/react";
import Input from "shared/Input/Input";
import React, { Fragment } from "react";
import { useHistory } from "react-router";
import { eventAnalytic } from "hooks/useAnalytics";
import logging from "utils/logging";
import { useSelector } from "react-redux";
import { RootState } from "store";

const SearchDropdown = () => {
  const ref = React.createRef<HTMLInputElement>();
  const history = useHistory();
  const { userInfo } = useSelector((state: RootState) => state.userInfo);

  //handle submit Form search
  const handleSubmit = (e: any) => {
    if (ref.current?.value) {
      logging(userInfo?.token || "", {
        category: "product",
        action: "search",
        target: ref.current?.value || "",
      });

      eventAnalytic({
        category: "Product",
        action: "Search",
        label: ref.current?.value.toLowerCase(),
      });
      //TODO: masukin hasil search ke database

      history.push(`/listing?name=${ref.current.value}`);
    }
    e.preventDefault();
  };

  return (
    <React.Fragment>
      <Popover className="relative">
        {({ open }) => {
          if (open) {
            setTimeout(() => {
              ref.current?.focus();
            }, 100);
          }

          return (
            <>
              <Popover.Button className="text-2xl md:text-[28px] w-12 h-12 rounded-full text-neutral-700 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-800 focus:outline-none flex items-center justify-center">
                <i className="las la-search"></i>
              </Popover.Button>

              <Transition
                show={open}
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1"
              >
                <Popover.Panel
                  static
                  className="absolute right-0 z-10 w-screen max-w-sm mt-3"
                >
                  <form action="" onSubmit={handleSubmit}>
                    <Input
                      ref={ref}
                      type="search"
                      placeholder="Tenda, Mobil, dsb..."
                    />
                    <input type="submit" hidden value="" />
                  </form>
                </Popover.Panel>
              </Transition>
            </>
          );
        }}
      </Popover>
    </React.Fragment>
  );
};

export default SearchDropdown;
